/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsApiKey,
    MelcoModelsApiKeyFromJSON,
    MelcoModelsApiKeyFromJSONTyped,
    MelcoModelsApiKeyToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsApiKey
 */
export interface MelcoModelsGenericList1MelcoModelsApiKey {
    /**
     * 
     * @type {Array<MelcoModelsApiKey>}
     * @memberof MelcoModelsGenericList1MelcoModelsApiKey
     */
    list: Array<MelcoModelsApiKey>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsApiKey
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsApiKey
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsApiKeyFromJSON(json: any): MelcoModelsGenericList1MelcoModelsApiKey {
    return MelcoModelsGenericList1MelcoModelsApiKeyFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsApiKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsApiKey {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsApiKeyFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsApiKeyToJSON(value?: MelcoModelsGenericList1MelcoModelsApiKey | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsApiKeyToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


